import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const SafeSendersOption: LazyOption = createLazyOption(
    {
        key: 'safeSenders',
        titleStringKey: 'optionTitle_safeSenders',
        searchTermsStringKey: 'optionTitle_safeSenders',
        allowedOptionKeys: ['SafeSendersList'],
        isHidden: () => {
            return isFeatureEnabled('tri-spamV2SenderDomain') || IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default SafeSendersOption;
